module.exports = __webpack_public_path__ + "img/afrosurance-logo-no-text.27ab50cc.png";